export class Phone {
  private phone: string;

  constructor(phone: string) {
    this.phone = phone;
  }

  hidePhoneNumber() {
    // Remove all non-numeric characters except hyphens and parentheses
    const cleaned = ("" + this.phone).replace(/[^\d()\-]/g, "");

    // Replace all digits except the last two with 'x'
    let digitIndex = 0;
    const formatted = cleaned
      .split("")
      .map((char) => {
        if (/\d/.test(char)) {
          digitIndex++;
          return digitIndex <= 8 ? "x" : char;
        }
        return char;
      })
      .join("");

    return formatted;
  }

  cleanPhoneNumber() {
    // Remove all non-numeric characters
    return this.phone.replace(/\D/g, "");
  }

  formattedPhoneNumber() {
    // Remove all non-numeric characters
    const numericValue = this.phone.replace(/\D/g, "");

    // Ensure the numeric value starts with '1'
    let withCountryCode = numericValue;
    if (numericValue.length > 0 && numericValue[0] !== "1") {
      withCountryCode = `1${numericValue}`;
    }

    // Format the number as 1 (123) 456-7890
    const formattedValue = withCountryCode.replace(
      /^1?(\d{0,3})(\d{0,3})(\d{0,4})$/,
      (match: string, p1: string, p2: string, p3: string) => {
        if (p3) {
          return `(${p1}) ${p2}-${p3}`;
        } else if (p2) {
          return `(${p1}) ${p2}`;
        } else if (p1) {
          return `(${p1}`;
        }
        return "";
      }
    );

    return formattedValue;
  }

  isValid(): boolean {
    // Define a regular expression for validating an email address
    const phoneRegex = /^(?:\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;
    return phoneRegex.test(this.phone);
  }

  toString(): string {
    return this.phone;
  }

  getErrorText() {
    if (!this.isValid()) return "Invalid phone number.";

    return "";
  }
}
